import screen1 from "./img/screen1.png"
import screen2 from "./img/screen2.png"
import screen3 from "./img/screen3.png"
import screen4 from "./img/screen4.png"
import screen5 from "./img/screen5.png"
import screen6 from "./img/screen6.png"

export const products = [
    {
      id: 1,
      img: screen1,
      link: "http://#",
    },
    {
      id: 2,
      img: screen2,
      link: "http://#",
    },
    {
      id: 3,
      img: screen3,
      link: "http://#",
    },
    {
      id: 4,
      img: screen4,
      link: "http://#",
    },
    {
      id: 5,
      img: screen5,
      link: "http://#",
    },
    {
      id: 6,
      img: screen6,
      link: "http://#",
    },
  ];